import axios from "axios";
import endPoints from "../../../../../config/endPoints";


// export const getAllDeptsApi = async(reqBody) => {
//   return axios.get(`${endPoints.departments}`, reqBody);
// }

// export const searchDeptsApi = async(reqBody) => {
//   return axios.post(`${endPoints.departments}/search`, reqBody);
// }

export const getAllDeptsApi = async(provinceId) => {
  
  return axios.get(`${endPoints.departments}/${provinceId}`);
};

export const searchDeptsApi = async(reqBody) => {
  
  return axios.post(`${endPoints.departments}/search`, reqBody);
};

